import { GET_ACTIVE_PROJECTS, LOADING } from "../actions/types";

const initialState = {
  projects: [],
  loading: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case LOADING:
      return {
        ...state,
        loading: true
      };
    case GET_ACTIVE_PROJECTS:
      return {
        ...state,
        projects: action.payload,
        loading: false
      };
    default:
      return state;
  }
}
